import styled from "styled-components";

import { DESKTOP_BREAKPOINT } from "../../components/AppShell/styles";

const MOBILE = `not all and (min-width: ${DESKTOP_BREAKPOINT})`;

export const Container = styled.div`
  padding-bottom: 2rem;
`;

/* A titled block of the screen: small uppercase label + card (same as /settings) */
export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1.5rem 2rem 0;

  @media ${MOBILE} {
    padding: 20px 20px 0;
  }
`;

/* Same green glow as the PLUS promo, so the screen reads as part of the plan */
/* Phones: stacked. Desktop: usage in its own column, centered in the block (like the dashboard card) */
export const Hero = styled.div`
  display: grid;
  grid-template-areas:
    "tag"
    "usage"
    "description";
  grid-template-columns: minmax(0, 1fr);
  gap: 0.75rem;
  align-items: center;
  padding: 1.5rem;
  background:
    radial-gradient(120% 140% at 0% 0%, rgba(87, 242, 139, 0.2) 0%, rgba(87, 242, 139, 0) 60%),
    var(--color-neutral-dark);
  border-radius: 1rem;
  box-shadow: inset 0 0 0 1px rgba(87, 242, 139, 0.25);

  @media ${MOBILE} {
    padding: 20px;
  }

  @media (min-width: ${DESKTOP_BREAKPOINT}) {
    grid-template-areas:
      "tag usage"
      "description usage";
    grid-template-columns: minmax(0, 1fr) 240px;
    column-gap: 2rem;
  }

  .tag {
    grid-area: tag;
    justify-self: start;
  }

  .usage {
    display: flex;
    flex-direction: column;
    grid-area: usage;
    gap: 0.5rem;

    @media (min-width: ${DESKTOP_BREAKPOINT}) {
      align-items: center;
      align-self: center;
      text-align: center;
    }
  }

  .description {
    grid-area: description;
  }

  .count {
    font-family: Inter, sans-serif;
    font-size: 0.9375rem;
    font-weight: 700;
    color: var(--color-neutral-150);

    strong {
      font-family: Poppins, sans-serif;
      font-size: 2rem;
      font-weight: 700;
      line-height: 2.5rem;
      color: var(--color-brand-plus);
    }
  }

  .progress {
    width: 100%;
    height: 6px;
    overflow: hidden;
    background: var(--color-neutral-base);
    border-radius: 100px;

    span {
      display: block;
      height: 100%;
      background: var(--color-brand-plus);
      border-radius: inherit;
    }
  }

  .description {
    font-size: 0.8125rem;
    line-height: 1.25rem;
    color: var(--color-neutral-150);
  }
`;

/* One grouped card with a row per benefit, like /settings' advanced options */
export const List = styled.ul`
  overflow: hidden;
  background: var(--color-neutral-dark);
  border-radius: 1rem;

  li + li {
    border-top: 1px solid var(--color-neutral-base);
  }

  button {
    display: flex;
    gap: 0.75rem;
    align-items: center;
    width: 100%;
    padding: 1rem 20px;
    text-align: left;
    transition: background-color 0.15s;

    &:hover {
      background: rgba(255, 255, 255, 0.03);
    }
  }

  .text {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 0.125rem;
    min-width: 0;
  }

  .title {
    font-family: Inter, sans-serif;
    font-size: 0.875rem;
    font-weight: 700;
    line-height: 1.25rem;
    color: var(--color-neutral-white);
  }

  .description {
    font-family: Inter, sans-serif;
    font-size: 0.75rem;
    line-height: 1rem;
    color: var(--color-neutral-150);
  }

  .use {
    flex-shrink: 0;
    font-family: Inter, sans-serif;
    font-size: 0.8125rem;
    font-weight: 700;
    color: var(--color-brand-plus);
  }

  .check {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    color: var(--color-neutral-darkness);
    background: var(--color-brand-plus);
    border-radius: 100%;
  }

  .chevron {
    display: flex;
    flex-shrink: 0;
    color: var(--color-neutral-150);
  }
`;

export const ManageLink = styled.button`
  display: block;
  margin: 2rem 2rem 0;
  font-family: Inter, sans-serif;
  font-size: 0.875rem;
  font-weight: 700;
  color: var(--color-neutral-150);

  &:hover {
    color: var(--color-neutral-white);
    text-decoration: underline;
  }

  @media ${MOBILE} {
    margin: 1.5rem 20px 0;
  }
`;
